// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.textarea[data-v-d1c8fb1e] {\n  border-radius: 5px;\n  border: 1px solid #e8e8e8;\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  font-family: var(--font-inter);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
